import React from "react";
import { Link } from "react-router-dom";
import { Gamepad2 } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-zinc-800 bg-black mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <Gamepad2 className="w-6 h-6 text-neon-cyan" />
            <span className="font-display font-black uppercase tracking-tighter">VideoGameMania</span>
          </div>
          <p className="text-sm text-zinc-500">Free online arcade games, brain teasers, IQ tests and viral quizzes. Play, compete, level up.</p>
        </div>
        <div>
          <h4 className="font-display font-bold uppercase text-sm mb-3 text-zinc-300">Play</h4>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/arcade" className="hover:text-neon-cyan">Arcade Games</Link></li>
            <li><Link to="/brain-teasers" className="hover:text-neon-cyan">Brain Teasers</Link></li>
            <li><Link to="/quizzes" className="hover:text-neon-cyan">Quizzes</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold uppercase text-sm mb-3 text-zinc-300">Compete</h4>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/leaderboard" className="hover:text-neon-cyan">Leaderboard</Link></li>
            <li><Link to="/play/reaction-duel" className="hover:text-neon-cyan">Play a Friend</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold uppercase text-sm mb-3 text-zinc-300">More</h4>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/news" className="hover:text-neon-cyan">Gaming News</Link></li>
            <li><Link to="/subscribe" className="hover:text-neon-cyan">Go Premium</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-6 text-center text-xs text-zinc-600">
        <span className="inline-flex items-center justify-center gap-1.5">
          <img src="https://designsystem.bowtiekreative.com/brand/btk-seal-white.png" alt="" width="14" height="14" loading="lazy" decoding="async" />
          © {new Date().getFullYear()} Video Game Mania. All rights reserved. · Powered by <a href="https://bowtiekreative.com" className="hover:text-neon-cyan">Bow Tie Kreative</a> · <a href="/sitemap.xml" className="hover:text-neon-cyan">Sitemap</a>
        </span>
      </div>
    </footer>
  );
}
